// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_VENTORY = [{
  id: 'ventory_caravan',
  factionId: FACTIONS.VENTORY,
  name: 'Караванщик пустыни',
  priceNumens: 8000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'ventory_accountant',
  factionId: FACTIONS.VENTORY,
  name: 'Банкир королей',
  priceNumens: 37000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'ventory_culture',
  factionId: FACTIONS.VENTORY,
  name: 'Покровитель искусств',
  priceNumens: 88000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED
  ]
}, {
  id: 'ventory_gold_legacy',
  factionId: FACTIONS.VENTORY,
  name: 'Бриллиантовый магнат',
  priceNumens: 110000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'ventory_ruby_legacy',
  factionId: FACTIONS.VENTORY,
  name: 'Король гильдий',
  priceCrystals: 400,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}, {
  id: 'ventory_player_arti',
  factionId: FACTIONS.VENTORY,
  name: 'Покровитель птиц',
  notObtainable: true,
  priceNumens: 0,
  skinRank: 5,
}];
